export const CERTIFICATION_STATUS = {
    PENDING: 'pending',
    CERTIFIED: 'certified',
    REJECTED: 'rejected',
    ALL: 'all'
}

export const CERTIFICATION_STATUS_LABELS = {
    [CERTIFICATION_STATUS.PENDING]: 'In attesa',
    [CERTIFICATION_STATUS.CERTIFIED]: 'Certificato',
    [CERTIFICATION_STATUS.REJECTED]: 'Rifiutato'
}

export const CERTIFICATION_STATUS_COLORS = {
    [CERTIFICATION_STATUS.PENDING]: 'warning',
    [CERTIFICATION_STATUS.CERTIFIED]: 'success',
    [CERTIFICATION_STATUS.REJECTED]: 'danger'
}

export const CERTIFICATION_STATUS_ICONS = {
    [CERTIFICATION_STATUS.PENDING]: 'cipClock',
    [CERTIFICATION_STATUS.CERTIFIED]: 'cipCheck',
    [CERTIFICATION_STATUS.REJECTED]: 'cipClose'
}

export const getStatusSelectOptions = (context, includeAll = false) => {
    const options = Object.entries(CERTIFICATION_STATUS_LABELS).map(([value, label]) => ({
        value,
        label
    }))
    if (includeAll) {
        options.unshift({ value: CERTIFICATION_STATUS.ALL, label: 'All' })
    }
    return options
}
